import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Set Pages
import { AllLeadsComponent } from './all-leads/all-leads.component';
import { UnPaidOrderComponent } from './un-paid-order/un-paid-order.component';
import { SalesAgentStatsComponent } from './sales-agent-stats/sales-agent-stats.component';
import { OrderManagementComponent } from './order-management/order-management.component';
import { AllSubscriptionsComponent } from './all-subscriptions/all-subscriptions.component';

const routes: Routes = [
  { path: 'all-leads',                            component: AllLeadsComponent },
  { path: 'unpaid-orders',                        component: UnPaidOrderComponent },
  { path: 'sales-agent-stats',                    component: SalesAgentStatsComponent },
  { path: 'order-management',                     component: OrderManagementComponent},
  { path: 'all-subscriptions',                    component: AllSubscriptionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QARoutingModule { }
